import { motion } from 'framer-motion';

/**
 * Glassmorphism card without backdrop-filter (performance-safe).
 * Uses transparent background + subtle border for the frosted effect.
 *
 * @param {boolean} accent - Adds indigo glow on hover
 * @param {boolean} interactive - Adds cursor pointer and click scale
 * @param {boolean} noPadding - Removes default padding
 * @param {string} className - Additional CSS classes
 */
export default function GlassCard({
  children,
  accent = false,
  interactive = false,
  noPadding = false,
  className = '',
  onClick,
  style,
  ...rest
}) {
  const classes = [
    'glass-card',
    accent && 'glass-card--accent',
    interactive && 'glass-card--interactive',
    className,
  ].filter(Boolean).join(' ');

  return (
    <motion.div
      className={classes}
      onClick={onClick}
      style={{
        ...(noPadding ? { padding: 0 } : {}),
        ...style,
      }}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      whileHover={interactive ? { scale: 1.01 } : undefined}
      whileTap={interactive ? { scale: 0.99 } : undefined}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
